// Environment configuration utility
const getEnvironment = () => {
  // Check multiple sources for environment
  const env = process.env.REACT_APP_ENV || 
               process.env.NODE_ENV || 
               window.APP_ENV || 
               'development';
  
  return env.toLowerCase();
};

const getApiUrl = () => {
  const environment = getEnvironment();
  
  // Check for runtime config first (from public/config.js)
  if (window.RUNTIME_CONFIG?.API_URL !== null && window.RUNTIME_CONFIG?.API_URL !== undefined) {
    return window.RUNTIME_CONFIG.API_URL;
  }
  
  // Check for environment variable override
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Use environment-specific URLs
  switch (environment) {
    case 'production':
    case 'prod':
      return 'https://concierge-fast-api-production-712015631621.us-central1.run.app/api';
    
    case 'development':
    case 'dev':
      // Check if running locally
      const isLocal = window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1';
      if (isLocal) {
        return 'http://localhost:8000/api';
      }
      return 'https://concierge-fast-api-development-712015631621.us-west3.run.app/api';
    
    case 'local':
      return 'http://localhost:8000/api';
    
    default:
      // Default to local for safety
      return 'http://localhost:8000/api';
  }
};

const environmentConfig = {
  environment: getEnvironment(),
  apiUrl: getApiUrl(),
  isProduction: () => {
    const env = getEnvironment();
    return env === 'production' || env === 'prod';
  },
  isDevelopment: () => {
    const env = getEnvironment();
    return env === 'development' || env === 'dev';
  },
  isLocal: () => {
    return window.location.hostname === 'localhost' || 
           window.location.hostname === '127.0.0.1';
  }
};

export default environmentConfig;